import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { usePublicList } from '../hooks/usePublicList';
import { buildImageUrl } from '../api/client';

export default function BlogDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: posts, loading } = usePublicList('blog');
  const post = posts.find((b) => String(b.id) === String(id));

  if (loading) return <section className="section"><div className="container"><p style={{ textAlign: 'center', color: '#6b7280' }}>Yüklənir...</p></div></section>;
  if (!post) return <section className="section"><div className="container"><p style={{ textAlign: 'center' }}>Yazı tapılmadı</p></div></section>;

  const paragraphs = (post.content || '').split('\n\n').map((text, i) => ({ id: `${post.id}-p-${i}`, text }));

  return (
    <section className="section">
      <div className="container" style={{ maxWidth: 860 }}>
        <button onClick={() => navigate('/bloq')} style={{ background: 'transparent', border: 'none', color: '#17b4b4', fontWeight: 600, cursor: 'pointer', marginBottom: 20 }}>← Bloqa qayıt</button>
        <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 24, textAlign: 'center' }}>{post.title}</h2>
        {post.image && (
          <div style={{ borderRadius: 8, overflow: 'hidden', marginBottom: 28, boxShadow: '0 10px 30px rgba(0,0,0,0.08)' }}>
            <img src={buildImageUrl(post.image)} alt={post.title} style={{ width: '100%', height: 380, objectFit: 'cover', display: 'block' }} />
          </div>
        )}
        {paragraphs.map((p) => (
          <p key={p.id} style={{ color: '#333', lineHeight: 1.75, fontSize: 15, marginBottom: 16 }}>{p.text}</p>
        ))}
      </div>
    </section>
  );
}
